import React from 'react'
import Myself from './myself/Myself';
import { HashRouter, Route, Routes } from "react-router-dom";
import About from './components/outlet/About';
import Work from './components/outlet/work/Work';
import Contact from './components/outlet/Contact';
import Education from './components/outlet/Education';
import Skills from './components/outlet/Skills';

export default function UserProfile() {
  return (
    <HashRouter>
    {/* <BrowserRouter> */}
      <Routes>
        <Route path="/" element={<Myself />}>
          <Route index element={<About />} />
          <Route path="work" element={ <Work /> } />
          <Route path="contact" element={ <Contact /> } />
          <Route path="education" element={ <Education /> } />
          <Route path="skills" element={ <Skills /> } />
        </Route>
      </Routes>
    {/* </BrowserRouter> */}
    </HashRouter>
  )
}
